<template>
  <div class="wxwork-guide">
    <div class="main">
      <div class="title">员工添加引导</div>
      <div class="tips">因企业微信开发规则限制，如需添加使用“校管家云校”的员工，请按以下引导操作</div>
      <div class="step-box">
        <div class="step-text">1、管理员登录企业微信管理后台</div>
        <div class="copy">
          <input type="text" v-model="link" class="copy-input" ref="copyInput"/>
          <van-button square round type="primary" class="copy-btn" @click="copyUrl">复制</van-button>
        </div>
      </div>
      <div class="step-box">
        <div class="step-text">2、点击“应用管理”，在第三方应用列表中找到“校管家云校”，点击进入应用管理</div>
        <img class="step-img" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/wxwork01.png" alt="">
      </div>
      <div class="step-box">
        <div class="step-text">3、在应用的“可见范围”设置处，设置需要添加使用的员工</div>
        <img class="step-img" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/wxwork02.png" alt="">
      </div>
      <div class="step-box">
        <div class="step-text">4、该员工的工作台即可看到“校管家云校”，点击即可进入使用</div>
      </div>
      <div class="step-box">
        <div class="step-text">5、员工进入云校后，默认为云校内的“普通员工”，如需调整员工的角色权限，在员工管理内进行编辑即可</div>
      </div>
    </div>
    <!-- <div class="footer">
      <van-button square round block class="delete" @click="goback()">我知道了</van-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'wxwork-guide',
  data() {
    return {
      pageTitle: "温馨提示",
      link: 'https://work.weixin.qq.com',
    }
  },
  methods: {
    copyUrl() {
      this.$refs.copyInput.select();
      this.$refs.copyInput.setSelectionRange(0, this.link.length);
      document.execCommand('copy');
      vant.Toast.success('复制成功');
      this.$refs.copyInput.blur();
    },
    goback() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.wxwork-guide {
  background: var(--white);
  display: flex;
  flex-direction: column;
  .main {
    padding: 24px 30px 0;
    flex: 1;
    overflow-y: auto;
    .title {
      font-size: 24px;
      height: 33px;
      line-height: 33px;
      font-weight: 500;
    }
    .tips {
      margin: 4px 0 24px;
      color: var(--g6);
    }
    .step-box {
      margin-bottom: 24px;
      .step-text {
        color: var(--g7);
      }
      .step-img {
        display: block;
        width: 100%;
        margin-top: 12px;
      }
      .copy {
        margin-top: 12px;
        height: 40px;
        line-height: 40px;
        display: flex;
        .copy-input {
          height: 40px;
          flex: 1;
          padding: 0 8px 0 16px;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          border: none;
          background: var(--g2);
        }
        .copy-btn {
          width: 90px;
          height: 40px;
          line-height: 40px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
  }
  .footer {
    height: 50px;
    background: var(--white);
    padding: 5px 10px;
    display: flex;
    .van-button {
      height: 40px;
      margin: 0 6px;
    }
  }
}
</style>
